import { useEffect, useState } from 'react';
import { IBaseResponse } from '@nkr/models/index';
import { IHardToMatchDonorReviewStatus } from '@nkr/models/hard-to-match/hard-to-match-donor-review';
import { AuthActionCreators } from '@nkr/store/authorization';
import { useAppHookContext } from '@nkr/utils/rest-api';

interface IRetVal {
    statuses: IHardToMatchDonorReviewStatus[],
    error: string
}

let cachedStatuses: IHardToMatchDonorReviewStatus[] = null;
let pendingStatuses: Promise<IHardToMatchDonorReviewStatus[]> = null;

const useHardToMatchReviewStatuses = (): IRetVal => {
    const { dispatch } = useAppHookContext();

    const [error, setError] = useState<string>('');
    const [statuses, setStatuses] = useState<IHardToMatchDonorReviewStatus[]>(cachedStatuses || []);

    const fetchStatuses = async (): Promise<IHardToMatchDonorReviewStatus[]> => {
        let options = {
            url: `${__API__}/admin/hard-to-match/review-statuses`
        };

        const response: IBaseResponse = await dispatch(AuthActionCreators.apiGet(options));

        if (!response?.data.success) {
            throw new Error('Unable to load review statuses');
        }

        return response.data.results;
    };

    const load = async () => {
        pendingStatuses = pendingStatuses || fetchStatuses();

        try {
            cachedStatuses = await pendingStatuses;
            setStatuses(cachedStatuses);
        } catch (err) {
            pendingStatuses = null;
            setError(err?.response?.data || err?.message || 'Unable to load review statuses');
        }
    };

    useEffect(() => {
        if (!cachedStatuses) {
            load();
        }
    }, []);

    return { statuses, error }
}

export default useHardToMatchReviewStatuses;
